import $ from "jquery";
import debug from 'bows/dist/bows.min.js';
import keyboardFocus from "./base/_keyboardFocus";
import smoothScroll from "./base/_smoothScroll";
import share from "./base/_share";
import scrollTriggers from "./modern/_scrollTriggers";
import gtmTracking from './gtm-tracking';

const $window = $(window);
const $document = $(document);
const log = debug("site");



class Site {
	constructor() {
		document.addEventListener('DOMContentLoaded', () => this.ready());
		window.addEventListener('load', () => this.load());
	}
	
	ready() {
		$('html').removeClass('no-js').addClass('js');
		const log = debug("site:domReady");
		console.log('site init modern');
		// tracking.init();


		keyboardFocus.init();
		smoothScroll.init();
		share.init();
        
		gtmTracking.init();
		const All_Details = document.querySelectorAll('details');

		All_Details.forEach(deet=>{
		deet.addEventListener('toggle', toggleOpenOneOnly)
		})

		function toggleOpenOneOnly(e) {
		if (this.open) {
			All_Details.forEach(deet=>{
			if (deet!=this && deet.open) deet.open = false
			});
		}
		}

				// Sticky tabs: make Kadence tab title lists stick to top and respect the sticky header
		(function initStickyTabs(){
			return;
			// run only if there are tab blocks on the page
			const tabs = document.querySelectorAll('.wp-block-kadence-tabs');
			if (!tabs || !tabs.length) return;

			const getHeaderOffset = () => {
				const header = document.querySelector('.sticky-nav') || document.querySelector('#header-modern');
				return header ? header.getBoundingClientRect().height : 0;
			};

					// Return header height only when the header is currently fixed/sticky.
			// This prevents using the header height for calculations when the header is not fixed
			// (e.g., immediately on page load), avoiding premature sticking.
			const headerFixedHeight = () => {
				const header = document.querySelector('.sticky-nav') || document.querySelector('#header-modern');
				if (!header) return 0;
				const isStickyClass = header.classList && header.classList.contains('sticky-nav');
				const computed = window.getComputedStyle(header);
				const isFixed = isStickyClass || computed.position === 'fixed';
				return isFixed ? header.getBoundingClientRect().height : 0;
			};

				// configurable offset (pixels) applied in addition to the header height
				// set offset to 40px on desktop widths > 900px, otherwise 0 on small screens
				const stickyOffset = (window.innerWidth && window.innerWidth > 900) ? 40 : 0;

				tabs.forEach(tabWrap => {
				const titleList = tabWrap.querySelector('.kt-tabs-title-list');
				if (!titleList) return;

				// Insert placeholder into the titleList's direct parent to avoid insertBefore errors
				const titleParent = titleList.parentNode || tabWrap;
				const placeholder = document.createElement('div');
				placeholder.className = 'kt-tabs-placeholder';
				// keep it in flow but zero height until needed
				placeholder.style.height = '0px';
				placeholder.style.width = '100%';
				// ensure it's invisible (it's only used to reserve layout space)
				placeholder.style.visibility = 'hidden';
				placeholder.style.display = 'block';
				titleParent.insertBefore(placeholder, titleList);

				let isSticky = false;
				let stickyLeft = null;
				let stickyWidth = null;

				// Helper to compute titleList total height including margins
				const computeTotalHeight = () => {
					const rect = titleList.getBoundingClientRect();
					const cs = window.getComputedStyle(titleList);
					const marginTop = parseFloat(cs.marginTop) || 0;
					const marginBottom = parseFloat(cs.marginBottom) || 0;
					return Math.round((rect.height || updatePlaceholderHeight()) + marginTop + marginBottom);
				};

				const applyUnstickyMargin = () => {
					try {
						const totalHeight = computeTotalHeight();
						titleList.style.marginTop = `${-totalHeight}px`;
						// ensure placeholder matches
						placeholder.style.height = `${totalHeight}px`;
					} catch (e) {}
				};

				const clearUnstickyMargin = () => {
					try { titleList.style.marginTop = ''; } catch (e) {}
				};

				const updatePlaceholderHeight = () => {
					// prefer offsetHeight for measured height
					const h = titleList.offsetHeight || titleList.getBoundingClientRect().height || 0;
					placeholder.style.height = `${h}px`;
					return h;
				};

				// Keep placeholder height in sync if the title list changes size (fonts, tabs added/removed)
				let titleResizeObserver = null;
				if (window.ResizeObserver) {
					titleResizeObserver = new ResizeObserver(() => {
						updatePlaceholderHeight();
						if (isSticky) {
							if (stickyLeft !== null && stickyWidth !== null) {
								titleList.style.left = `${stickyLeft}px`;
								titleList.style.width = `${stickyWidth}px`;
							} else {
								const bounds = placeholder.getBoundingClientRect();
								titleList.style.left = `${bounds.left}px`;
								titleList.style.width = `${bounds.width}px`;
							}
						} else {
							applyUnstickyMargin();
						}
					});
					titleResizeObserver.observe(titleList);
				}

				// Ensure initial unsticky margin is applied so the placeholder doesn't
				// visually push the titleList before any interaction.
				applyUnstickyMargin();

				const stick = (topOffset) => {
					if (isSticky) return;
					// Use the placeholder (in-flow element) to compute left/width
					// which better matches the layout the element will occupy.
					const bounds = placeholder.getBoundingClientRect();

					// compute height of the titleList including vertical margins
					const rect = titleList.getBoundingClientRect();
					const cs = window.getComputedStyle(titleList);
					const marginTop = parseFloat(cs.marginTop) || 0;
					const marginBottom = parseFloat(cs.marginBottom) || 0;
					const totalHeight = Math.round((rect.height || updatePlaceholderHeight()) + marginTop + marginBottom);

					// set placeholder height and apply fixed positioning in the same
					// synchronous block so the browser paints the final state once
					// instead of showing an intermediate pushed layout which causes
					// a visual jump.
					const prevTransition = titleList.style.transition || '';
					titleList.style.transition = 'none';

					// ensure any negative margin isn't present while sticky
					clearUnstickyMargin();

					// capture unstuck left/width so sticky can retain exact position
					stickyLeft = Math.round(rect.left);
					stickyWidth = Math.round(rect.width);

					// apply fixed positioning first (using the titleList's current
					// viewport rect so it visually stays in place) so that when we
					// set the placeholder height it does not push the element.
					titleList.style.boxSizing = 'border-box';
					titleList.style.position = 'fixed';
					// keep it visually where it is for the instant switch
					titleList.style.top = `${Math.round(rect.top)}px`;
					titleList.style.left = `${stickyLeft}px`;
					titleList.style.width = `${stickyWidth}px`;
					titleList.style.zIndex = '999';



					// now set placeholder height to preserve flow for the rest of the content
					placeholder.style.height = `${totalHeight}px`;

					// finally, place the fixed titleList at the sticky offset
					titleList.style.top = `${topOffset}px`;
					titleList.classList.add('is-sticky');
					// enforce zero side margins while sticky (important) so the fixed
					// element aligns with the viewport edges as intended
					try {
						titleList.style.setProperty('margin-left', '0', 'important');
						titleList.style.setProperty('margin-right', '0', 'important');
					} catch (e) {}
					isSticky = true;

					// restore transition after a tick so future changes animate normally
					setTimeout(() => { try { titleList.style.transition = prevTransition; } catch (e) {} }, 50);
				};

				const unstick = () => {
					if (!isSticky) return;
					// Apply the unsticky negative margin and then restore flow
					applyUnstickyMargin();

					// Temporarily disable transitions to avoid animated jumps
					const prevTransition = titleList.style.transition || '';
					titleList.style.transition = 'none';

					// Remove fixed positioning so the titleList returns to flow
					titleList.style.position = '';
					titleList.style.top = '';
					titleList.style.left = '';
					titleList.style.width = '';
					titleList.style.zIndex = '';
					titleList.classList.remove('is-sticky');


					// collapse the placeholder after the titleList is back in-flow
					placeholder.style.height = '0px';

					// clear stored sticky dimensions
					stickyLeft = null;
					stickyWidth = null;

					isSticky = false;

					// restore any previous transition
					setTimeout(() => { try { titleList.style.transition = prevTransition; } catch (e) {} }, 50);
					// remove enforced inline margins
					try {
						titleList.style.removeProperty('margin-left');
						titleList.style.removeProperty('margin-right');
					} catch (e) {}
				};

				// Use the placeholder (the in-flow position of the title list) as the
				// trigger target so the tabs only stick when the title list itself
				// reaches the header bottom. Observing the larger parent container
				// could make the tabs stick too early if the parent top passes the
				// header while the titles are still lower inside it.
				const parentGroup = tabWrap.parentNode || tabWrap;
				// Add a debug class so this container is easy to spot in the DOM during testing
				try { parentGroup.classList.add('tns-tabs-parent-debug'); } catch (e) {}
				const triggerTarget = placeholder; // observe the placeholder by default

				let topObserver = null;
				const createTopObserver = () => {
					if (topObserver) {
						try { topObserver.disconnect(); } catch (e) {}
						topObserver = null;
					}
					const headerOffset = Math.ceil(headerFixedHeight());
					const rootMargin = headerOffset ? `-${headerOffset}px 0px 0px 0px` : '0px 0px 0px 0px';
					topObserver = new IntersectionObserver((entries) => {
						entries.forEach(entry => {
							// Keep the IntersectionObserver as a passive helper, but use
							// the scroll-driven check (below) as the authoritative
							// stick/unstick decision to avoid edge cases.
							try { console.log('[tabs] intersect entryIsIntersecting', entry.isIntersecting); } catch (e) {}
						});
					}, {root: null, threshold: [0], rootMargin});

					try {
						topObserver.observe(triggerTarget);
					} catch (e) {
						topObserver.observe(parentGroup);
					}
				};

				// rAF-throttled scroll handler to deterministically control sticky state
				let ticking = false;
				const checkStickyState = () => {
					ticking = false;
					const headerH = headerFixedHeight();
					const triggerRect = triggerTarget.getBoundingClientRect();
					const triggerAbs = triggerRect.top + window.scrollY;
					const headerBottom = window.scrollY + headerH;
					const scrolled = window.scrollY >= 1;

					// If parent group's bottom is at or above the header bottom,
					// the whole tab area has scrolled past — make sure we unstick.
					const parentRect = parentGroup.getBoundingClientRect();
					if (parentRect.bottom <= headerH) {
						unstick();
						return;
					}

							const willStick = scrolled && triggerAbs <= headerBottom + stickyOffset;
					if (willStick && !isSticky) {
						stick(headerH + stickyOffset);
					} else if (!willStick && isSticky) {
						unstick();
					}
				};

				const onScroll = () => {
					if (!ticking) {
						ticking = true;
						requestAnimationFrame(checkStickyState);
					}
				};

				window.addEventListener('scroll', onScroll, { passive: true });

				// create initially
				createTopObserver();

				// No MutationObserver: we rely on absolute-position checks and resize handlers
				// to re-evaluate stickiness when layout changes.

				// recreate observer on resize (header height may change)
				let topObserverResizeTimer = null;
				const onWindowResizeTop = () => {
					clearTimeout(topObserverResizeTimer);
					topObserverResizeTimer = setTimeout(() => {
						createTopObserver();
						// if already scrolled past, ensure sticky state is correct
						const h = headerFixedHeight();
						const triggerAbs = triggerTarget.getBoundingClientRect().top + window.scrollY;
						const headerBottom = window.scrollY + h;
						if (window.scrollY >= 1 && triggerAbs <= headerBottom + stickyOffset) {
							stick(h + stickyOffset);
						} else {
							unstick();
						}
					}, 100);
				};
				window.addEventListener('resize', onWindowResizeTop);

				// run an immediate check in case page loads already scrolled
				(function initialCheck(){
					const h = headerFixedHeight();
					const triggerAbs = triggerTarget.getBoundingClientRect().top + window.scrollY;
					if (window.scrollY >= triggerAbs - h - stickyOffset && window.scrollY >= 1) {
						stick(h + stickyOffset);
					}
				})();

				// Observe the parent container to stop sticking when parent scrolls out
				const bottomObserver = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if (!entry.isIntersecting && entry.boundingClientRect.top < 0 && entry.boundingClientRect.bottom < headerFixedHeight()) {
							// parent scrolled past / out of view - ensure titleList is not stuck
							unstick();
						}
					});
				}, {root: null, threshold: [0, 1]});

				bottomObserver.observe(tabWrap);

				// Clicking a tab should scroll to the top of the tab section (accounting for sticky header)
				const onTitleListClick = (e) => {
					// find an anchor or button that represents a tab
					const target = e.target.closest('a, button');
					if (!target) return;
					// locate the top of the tabWrap and scroll to it with offset
					const headerHeight = getHeaderOffset();
					const extraOffset = 8; // breathing room
					const rect = tabWrap.getBoundingClientRect();
					const absoluteTop = window.scrollY + rect.top - headerHeight - extraOffset;
					window.scrollTo({ top: absoluteTop, behavior: 'smooth' });
				};
				titleList.addEventListener('click', onTitleListClick);

				// Recompute widths/positions on resize
				const onWindowResizeSticky = () => {
					if (isSticky) {
						const bounds = placeholder.getBoundingClientRect();
						titleList.style.left = `${bounds.left}px`;
						titleList.style.width = `${bounds.width}px`;
					}
				};
				window.addEventListener('resize', onWindowResizeSticky);

				// Cleanup routine to remove observers and listeners when the page unloads
				const cleanup = () => {
					try {
						if (titleResizeObserver) titleResizeObserver.disconnect();
					} catch (e) {}
					try {
						if (topObserver) topObserver.disconnect();
					} catch (e) {}
					try {
						if (bottomObserver) bottomObserver.disconnect();
					} catch (e) {}
					try { window.removeEventListener('scroll', onScroll, { passive: true }); } catch (e) { try { window.removeEventListener('scroll', onScroll); } catch (e) {} }
					try { window.removeEventListener('resize', onWindowResizeTop); } catch (e) {}
					try { window.removeEventListener('resize', onWindowResizeSticky); } catch (e) {}
					try { titleList.removeEventListener('click', onTitleListClick); } catch (e) {}
					try { clearTimeout(topObserverResizeTimer); } catch (e) {}
				};

				// Run cleanup on pagehide and beforeunload to avoid leaks in SPA-style navigation
				window.addEventListener('pagehide', cleanup);
				window.addEventListener('beforeunload', cleanup);
			});
		})();
		$(document).ready(function(){
			scrollTriggers.init();
		
		});
		function jumpElement(hashTag){
			var headerHeight = $('#header-modern').height();
			//var objOffset = $(hashTag).offset().top;
			var elem = document.querySelector(hashTag);
			var objOffset = elem.offsetTop;//getBoundingClientRect().top;
			

			var $offset = 75;
			if ($(window).width()<901){
				$offset = 80;
			}
			console.log('header ' + headerHeight + 'objOffset '+objOffset + ' offset ' +$offset);
			var yOffset =  objOffset - headerHeight - $offset;
			$(window).scrollTop(yOffset);
			document.scrollingElement.scrollTop = yOffset;
			console.log("hash scroll " + yOffset);
			$('.debug-element').html(yOffset + ' ' +hashTag);
		}
		$(window).on('load', function(){

			var hashTag = window.location.hash;
			if (hashTag){
				/*var headerHeight = $('#header-modern').height();
				//var objOffset = $(hashTag).offset().top;
				var elem = document.querySelector(hashTag);
				var objOffset = elem.getBoundingClientRect().top;

				var $offset = 60;
				if ($(window).width()<901){
					$offset = 60;
				}
				var yOffset =  objOffset - headerHeight - $offset;
				$(window).scrollTop(yOffset);
				console.log("init hash scroll " + yOffset);
				$('.debug-element').html(yOffset + ' ' +hashTag);*/
				jumpElement(hashTag);
				/*setTimeout(function(){
					var hashTag = window.location.hash;
					jumpElement(hashTag);
				},700);*/
			}

			let activeJumpURLs = $('ul#mega-menu-modern_global li.mega-current-menu-item a[href*="#"]');
	
			
			$(activeJumpURLs).each(function( index ) {
				let inputString = $(this).attr('href');
				let parts = inputString.split('#');
				let hash = $(this).prop('hash');
				let $where = $(hash);
				// Return the part after the # character
				$(this).attr('href','#'+parts[1]);
				$(this).parent().removeClass('mega-current-menu-item');
				$(this).on('click',function(e){

				var elem = document.querySelector(hash);
				var objOffset = elem.getBoundingClientRect().top;
					if ($('#mega-menu-wrap-modern_global .mega-menu-toggle').hasClass('mega-menu-open')){
						console.log('gogo');
						$('#mega-menu-wrap-modern_global .mega-menu-toggle').trigger( "click" );
					}
					if (elem){
						e.preventDefault();
						/*let topDistance = objOffset;
						let $header = $('#header-modern');
						let $offset = 60;
						if ($(window).width()<901){
							$offset = 100;
						}
						topDistance = parseInt(topDistance) - $header.height() - $offset;
						$(window).scrollTop(topDistance);
						$('.debug-element').html(topDistance + ' ' + hash);
						console.log('vert scroll mega link ' + topDistance);
						//window.history.hash = hash;*/
						jumpElement(hash);
						window.history.pushState(null, null, hash);
					}
				});
			});

			//Adds classes to all FundraiseUp elements
			// Loop through all iframes on the page
			$('main.site-content iframe').each(function() {
				var iframeTitle = $(this).attr('title');
				if (iframeTitle){
					iframeTitle = iframeTitle.toLowerCase();
					iframeTitle = iframeTitle.replace(/\s+/g, '-');
					$(this).addClass(iframeTitle);
					//console.log('Title ' + iframeTitle);
				}
				
			});
			$('.goal-meter').removeAttr('style');
		});

		//Sticky nav

		//shrink nav
		$(function(){

			window.shrunknav = false;
			if ($(window).scrollTop() >= 80) { // if equal to or greater than 100 and hasBeenTrigged is set to false.
				$('#header-modern').addClass('sticky-nav');
				window.shrunknav = true;
			}
			$(window).scroll(function() {
				if ($(this).scrollTop() >= 80) { // if equal to or greater than 100 and hasBeenTrigged is set to false.
					$('#header-modern').addClass('sticky-nav');
					window.shrunknav = true;
				} else if(window.shrunknav) {
				$('#header-modern').removeClass('sticky-nav');
				window.shrunknav = false;
				}
			});
		});

    // log('document.DOMContentLoaded');
	}

	load() {
		const log = debug("site:windowLoad");
		// log("window.onload");

		// example of ES2015 modules loading & tree shaking
		// emptyLinks();
	}

}

export default Site;
window.site = new Site();
